var _circle, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatars = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 28,
  fill: "currentColor"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 56,
  height: 56
}, /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 28,
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.765 63.201c9.882-.996 27.882-14.54 18.176-39.241L42 18.183l-4.941 4.382 3-8.565-5.118 5.777c-2.47-2.79-9.388-7.45-17.294-3.785-4.938 2.862-7.15 8.686-8.394 11.958-.4 1.055-.7 1.845-.959 2.185-.128.168-.317.486-.573.917C5.847 34.203.369 43.41-11.118 44.676c-6.568 0-11.117-4.78-12.882-6.773 2.47 8.433 12.07 25.298 30.706 25.298l.243 1.363v.002c.639 3.572 1.713 9.581 2.227 13.65l2.471-14.417H15l2.294 13.62 2.47-14.218ZM.678 49.79c4.244 2.442 9.11 3.036 13.842 2.546-2.335 1.195-5.37 2.268-9.41 3.281 12.832 3.84 21.53.737 29.208-11.977 0 0-.165.072-.449.188-1.254.482-4.896 1.61-7.863-.19-4.374-2.654-5.698-5.918-5.698-5.918-3.8 7.702-13.08 11.546-19.63 12.07Zm25.616-25.233 4.059-5.577c-.706.132-2.153.637-3 1.593s-1.118 3.055-1.059 3.984Zm-8.117 53.46c.14 0 2.176.133 3.176.2l-.882 2.39-2.294-2.59Zm-.53.2L18 82l1.765-1.195-2.118-2.59Zm-2.294 2.589 1.765-2.59.176 3.586-1.941-.996Zm-2.647-2.191L12 80.606l-2.647-1.992h3.353Zm-1.059 2.19-2.294-1.593L9.529 82l2.118-1.195ZM9 79.013V82l-1.765-.598L9 79.012Z",
  fill: "#fff"
}))));
export default SvgAvatars;